import { Injectable, OnInit } from '@angular/core';
import { AppConfigService } from '../reactive-forms/services/app-config.service';
import { SBHttpServicesService } from './services/sbhttp-services.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UserPermissions } from '../UserPermissions';
import { HttpService } from 'src/app/shared/services/HttpClientServices/Http.service';
import { Observable, from, of } from 'rxjs';
@Injectable()
export class userPermissionsService  {
  isAdmin: boolean;
  constructor(private environment: AppConfigService,  private httpService: SBHttpServicesService,
    private jwtHelper: JwtHelperService,private _httpService: HttpService) {

  }
  async CheckSecurityKey(ScreenURL: string): Promise<any>  {
    var IgnorSecurity = localStorage.getItem("IgnorSecurity");
    if (IgnorSecurity && IgnorSecurity == 'true')
      this.EnableAllPermission();

    if (ScreenURL) {
      var token = localStorage.getItem("ODataToken");
      if (token && !this.jwtHelper.isTokenExpired(token)) {
        var AllToken = this.jwtHelper.decodeToken(token);
        if (AllToken["role"]) {
            this.isAdmin = AllToken["role"] == 'Administrator';
            var RoleClaimurl = this.environment.oDataApi + `/api/HH_SA_RolePermission/GetRolePermission?Route=${ScreenURL}`;
            var data = await this.httpService.httpGetRequest(RoleClaimurl);
            data=data[0];
            if (data) {
              UserPermissions.CanRead = data.CanRead == 1 ? true : false;
              UserPermissions.CanInsert = data.CanInsert == 1 ? true : false;
              UserPermissions.CanUpdate = data.CanUpdate == 1 ? true : false;
              UserPermissions.CanDelete = data.CanDelete == 1 ? true : false;
              UserPermissions.CanExecute = data.CanExecute == 1 ? true : false;
              UserPermissions.CanViewAttachments = data.CanViewAttachments == 1 ? true : false;
              UserPermissions.CanAddAttachments = data.CanAddAttachments == 1 ? true : false;
              UserPermissions.CanDeleteAttachments = data.CanDeleteAttachments == 1 ? true : false;
            }
            else
              this.DisableAllPermissions();
        }
        else {
          this.DisableAllPermissions();
        }

      }
    }
    else {
      this.EnableAllPermission();
    }
    return UserPermissions;
  }
  async CheckSecurityKeyPermision(ScreenSecKey: string): Promise<any>  {
    var IgnorSecurity = localStorage.getItem("IgnorSecurity");
    if (IgnorSecurity && IgnorSecurity == 'true')
      this.EnableAllPermission();

    if (ScreenSecKey) {
      var token = localStorage.getItem("ODataToken");
      if (token && !this.jwtHelper.isTokenExpired(token)) {
        var AllToken = this.jwtHelper.decodeToken(token);
        if (AllToken["role"]) {
          this.isAdmin = AllToken["role"] == 'Administrator';
          var RoleClaimurl = this.environment.oDataApi + `/api/HH_SA_RolePermission/GetRolePermissionWithLicense?keyID=${ScreenSecKey}`;
          var data = await this.httpService.httpGetRequest(RoleClaimurl);
          data=data[0];
          if (data) {
            data.CanRead = data.CanRead == 1 ? true : false;
            data.CanInsert = data.CanInsert == 1 ? true : false;
            data.CanUpdate = data.CanUpdate == 1 ? true : false;
            data.CanDelete = data.CanDelete == 1 ? true : false;
            data.CanExecute = data.CanExecute == 1 ? true : false;
            data.CanViewAttachments = data.CanViewAttachments == 1 ? true : false;
            data.CanAddAttachments = data.CanAddAttachments == 1 ? true : false;
            data.CanDeleteAttachments = data.CanDeleteAttachments == 1 ? true : false;
            return data;
          }
          else
            this.DisableAllPermissions();
        }
        else {
          this.DisableAllPermissions();
        }

      }
    }
    else {
      this.EnableAllPermission();
    }
    return UserPermissions;
  }
  
  async CheckSecurityKeysPermision(ScreenSecKeys: string[]): Promise<any>  {
    var AllPermissions: { [keys: string] : typeof UserPermissions; } = {};
    var IgnorSecurity = localStorage.getItem("IgnorSecurity");
    if (IgnorSecurity && IgnorSecurity == 'true')
      this.EnableAllPermission();

      var token = localStorage.getItem("ODataToken");
      if (token && !this.jwtHelper.isTokenExpired(token)) {
        var AllToken = this.jwtHelper.decodeToken(token);
        if (AllToken["role"]) {
            this.isAdmin = AllToken["role"] == 'Administrator';
            var RoleClaimurl = this.environment.oDataApi + `/api/HH_SA_RolePermission/GetRolePermissionsWithLicense`;
            var data = await this.httpService.httpPostRequest(RoleClaimurl,ScreenSecKeys);
            var dataMap = {};
            data.forEach(item => {
              const { KeyID, ...rest } = item;
              dataMap[KeyID] = rest;
            });

              for(var key in ScreenSecKeys){
                if(dataMap[ScreenSecKeys[key]] == null){
                  this.DisableAllPermissions();
                  AllPermissions[ScreenSecKeys[key]] = UserPermissions;
                }
                else{
                  AllPermissions[ScreenSecKeys[key]] = {
                    'CanRead' : dataMap[ScreenSecKeys[key]].CanRead == 1 ? true : false,
                    'CanUpdate' : dataMap[ScreenSecKeys[key]].CanUpdate == 1 ? true : false,
                    'CanInsert' : dataMap[ScreenSecKeys[key]].CanInsert == 1 ? true : false,
                    'CanDelete' : dataMap[ScreenSecKeys[key]].CanDelete == 1 ? true : false,
                    'CanExecute' : dataMap[ScreenSecKeys[key]].CanExecute == 1 ? true : false,
                    'CanViewAttachments' : dataMap[ScreenSecKeys[key]].CanViewAttachments == 1 ? true : false,
                    'CanAddAttachments' : dataMap[ScreenSecKeys[key]].CanAddAttachments == 1 ? true : false,
                    'CanDeleteAttachments' : dataMap[ScreenSecKeys[key]].CanDeleteAttachments == 1 ? true : false,
                  }
                }
              }
        }
        else {
          this.DisableAllPermissions();
          for(var key in ScreenSecKeys){
            AllPermissions[ScreenSecKeys[key]] = UserPermissions;
          }
        }
      }
    
    return AllPermissions;
  }

  obs_CheckSecurityKeyPermision(ScreenSecKey: string): Observable<any> {

    return from(new Promise<any>(async (resolve, reject) => {
      var __UserPermissions={CanRead:null,CanInsert:null,CanUpdate:null,CanDelete:null,CanExecute:null,CanViewAttachments:null,CanAddAttachments:null,CanDeleteAttachments:null};
    var IgnorSecurity = localStorage.getItem("IgnorSecurity");
    if (IgnorSecurity && IgnorSecurity == 'true')
      __UserPermissions={CanRead:true,CanInsert:true,CanUpdate:true,CanDelete:true,CanExecute:true,CanViewAttachments:true,CanAddAttachments:true,CanDeleteAttachments:true};

    if (ScreenSecKey) {
      var token = localStorage.getItem("ODataToken");
      if (token && !this.jwtHelper.isTokenExpired(token)) {
        var AllToken = this.jwtHelper.decodeToken(token);
        if (AllToken["role"]) {
          if (AllToken["role"] == 'Administrator') {
            this.isAdmin = true;
            __UserPermissions={CanRead:true,CanInsert:true,CanUpdate:true,CanDelete:true,CanExecute:true,CanViewAttachments:true,CanAddAttachments:true,CanDeleteAttachments:true};
          }
          else {
            this.isAdmin = false;
            var RoleClaimurl = this.environment.oDataApi + `/HH_SA_RolePermission?$filter=RoleID eq '${AllToken["role"]}' and keyID eq '${ScreenSecKey}'`;
            this._httpService.httpGetRequest(RoleClaimurl).subscribe(data=>{
              data = data['value'][0];
              if (data) {
                __UserPermissions.CanRead = data['CanRead'] == 1 ? true : false;
                __UserPermissions.CanInsert = data['CanInsert'] == 1 ? true : false;
                __UserPermissions.CanUpdate = data['CanUpdate'] == 1 ? true : false;
                __UserPermissions.CanDelete = data['CanDelete'] == 1 ? true : false;
                __UserPermissions.CanExecute = data['CanExecute'] == 1 ? true : false;
                __UserPermissions.CanViewAttachments = data['CanViewAttachments'] == 1 ? true : false;
                __UserPermissions.CanAddAttachments = data['CanAddAttachments'] == 1 ? true : false;
                __UserPermissions.CanDeleteAttachments = data['CanDeleteAttachments'] == 1 ? true : false;
          }
                else
                __UserPermissions={CanRead:false,CanInsert:false,CanUpdate:false,CanDelete:false,CanExecute:false,CanViewAttachments:false,CanAddAttachments:false,CanDeleteAttachments:false};
              })
            
          }
        }
        else {
          __UserPermissions={CanRead:false,CanInsert:false,CanUpdate:false,CanDelete:false,CanExecute:false,CanViewAttachments:false,CanAddAttachments:false,CanDeleteAttachments:false};
        }

      }
    }
    else {
      __UserPermissions={CanRead:true,CanInsert:true,CanUpdate:true,CanDelete:true,CanExecute:true,CanViewAttachments:true,CanAddAttachments:true,CanDeleteAttachments:true};
    }
  
      resolve(__UserPermissions);
    }));
  }

  EnableAllPermission() {
    UserPermissions.CanRead = true;
    UserPermissions.CanInsert = true;
    UserPermissions.CanUpdate = true;
    UserPermissions.CanDelete = true;
    UserPermissions.CanExecute = true;
    UserPermissions.CanViewAttachments = true;
    UserPermissions.CanAddAttachments = true;
    UserPermissions.CanDeleteAttachments = true;
  }
  DisableAllPermissions() {
    UserPermissions.CanRead = false;
    UserPermissions.CanInsert = false;
    UserPermissions.CanUpdate = false;
    UserPermissions.CanDelete = false;
    UserPermissions.CanExecute = false;
    UserPermissions.CanViewAttachments = false;
    UserPermissions.CanAddAttachments = false;
    UserPermissions.CanDeleteAttachments = false;
  }
  }
